import React from "react";
import ButtonBase from "@mui/material/ButtonBase";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import AddIcon from "@mui/icons-material/Add";
import CircularProgress from "@mui/material/CircularProgress";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";

export default function MoreOptionsMenu({ onAddNew, creating }) {
  const handleAddNew = async popupState => {
    if (onAddNew) await onAddNew();
    popupState.close();
  };

  return (
    <PopupState variant="popover" popupId="grouped-items-more-options">
      {popupState => (
        <>
          <ButtonBase aria-label="more options" {...bindTrigger(popupState)}>
            {creating ? <CircularProgress size={18} sx={{ mr: 0.5 }} /> : <MoreVertIcon />} More
            Options
          </ButtonBase>
          <Menu id="grouped-items-more-options" {...bindMenu(popupState)}>
            <MenuItem onClick={() => handleAddNew(popupState)}>
              <ListItemIcon>
                <AddIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Add New Grouped Item" />
            </MenuItem>
          </Menu>
        </>
      )}
    </PopupState>
  );
}

